
export default {
  // Profile
  "profile_reviews": "Avaliações",
  "profile_no_reviews": "Ainda não há avaliações",
  "profile_share_experience": "Compartilhe sua experiência com a comunidade de fotografia!",
  "verified_traveler": "Viajante Verificado",
  "verified_creative": "Criativo Verificado",
  "verified_traveler_tooltip": "Este usuário é um viajante verificado",
  "verified_creative_tooltip": "Fotógrafo ou profissional criativo verificado",
  "favorite_airports": "Aeroportos Favoritos",
  "no_favorite_airports": "Ainda não há aeroportos favoritos",
  "user_favorites": "Favoritos do Usuário",
  "manage_favorites": "Gerenciar Favoritos"
};
